// Hosts que servem o site de produção (o mesmo bundle responde nos quatro).
// `www` e `voopter.com` precisam ser "production", senão o alt-redirect e o
// banner inline leem o S3 de staging e os eventos do GTM saem com o sufixo
// "-ambiente desconhecido", que nenhuma tag reconhece.
const PRODUCTION_HOSTNAMES = [
  "voopter.com.br",
  "www.voopter.com.br",
  "new.voopter.com.br",
  "voopter.com",
];

function getEnvironment() {
  // Ponto final (`voopter.com.br.`) é o mesmo host.
  const hostname = window.location.hostname.replace(/\.$/, "");

  if (PRODUCTION_HOSTNAMES.includes(hostname)) {
    return "production";
  } else if (hostname === "staging.voopter.com.br") {
    return "staging";
  } else if (hostname === "homolog.voopter.com.br") {
    return "homolog";
  } else if (hostname === "localhost" || hostname.startsWith("127.0.0.1")) {
    return "development";
  } else {
    return "ambiente desconhecido";
  }
}

export { getEnvironment };
